// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { db } from '../FireBase'; // Import Firestore
// import { doc, getDoc, deleteDoc, query, collection, where, getDocs,updateDoc } from 'firebase/firestore';
// import { Container, Col, Row, Card, Table, Button } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
// import ToastAlert from '../components/ToastAlert'; // Assuming you have a ToastAlert component
// import { Link } from 'react-router-dom';
// import '../css/font.css';
// import Loading from '../components/Loading';

// const CustomerDetails = () => {
//     const { cusmid } = useParams(); // Get the customer ID from the URL
//     const navigate = useNavigate();
//     const [customer, setCustomer] = useState(null);
//     const [showToast, setShowToast] = useState(false);
//     const [toastMessage, setToastMessage] = useState('');
//     const [toastVariant, setToastVariant] = useState('');
//     const [schemes, setSchemes] = useState([]);
//     const [transactions, setTransactions] = useState([]);
//     const [totalSchemes, setTotalSchemes] = useState(0);
//     const [completedSchemes, setCompletedSchemes] = useState(0);
//     const [activeSchemes, setActiveSchemes] = useState(0);
//     const [showModal, setShowModal] = useState(false);
//     const [newTransportLocation, setNewTransportLocation] = useState('');

 

//     useEffect(() => {
//         const fetchCustomerDetails = async () => {
//             try {
//                 if (!cusmid) {
//                     console.error('Customer ID (cusmid) is undefined');
//                     return;
//                 }

//                 const customersQuery = query(collection(db, 'users'), where('cusmid', '==', cusmid));
//                 const querySnapshot = await getDocs(customersQuery);
//                 if (!querySnapshot.empty) {
//                     const customerDoc = querySnapshot.docs[0];
//                     setCustomer({ cusmid: customerDoc.id, ...customerDoc.data() });
//                 } else {
//                     console.log('No such document!');
//                 }
//             } catch (error) {
//                 console.error('Error fetching customer details:', error);
//             }
//         };

//         const fetchSchemeDetails = async () => {
//             try {
//                 const subscriptionsQuery = query(collection(db, 'subscriptions'), where('userId', '==', cusmid));
//                 const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
//                 const schemePromises = subscriptionsSnapshot.docs.map(async (subscriptionDoc) => {
//                     const schemeId = subscriptionDoc.data().schemeId;
//                     const paidMonths = subscriptionDoc.data().paidMonths;
//                     const totalMonths = subscriptionDoc.data().totalMonths; 
//                     const purchasedQuantity = subscriptionDoc.data().quantity;
//                     const schemeRef = doc(db, 'schemes', schemeId);
//                     const schemeDoc = await getDoc(schemeRef);
//                     if (schemeDoc.exists()) {
//                         return { id: schemeDoc.id, ...schemeDoc.data(), paidMonths,totalMonths,purchasedQuantity };
//                     } else {
//                         console.log(`No such scheme document for schemeId: ${schemeId}`);
//                         return null;
//                     }
//                 });

//                 const schemesData = await Promise.all(schemePromises);
//                 const filteredSchemes = schemesData.filter(scheme => scheme !== null);
//                 setSchemes(filteredSchemes);

//                 setTotalSchemes(filteredSchemes.length);
//                 setCompletedSchemes(filteredSchemes.filter(scheme => parseInt(scheme.paidMonths) === parseInt(scheme.totalMonths)).length);
//                 setActiveSchemes(filteredSchemes.filter(scheme => parseInt(scheme.paidMonths) < parseInt(scheme.totalMonths)).length);
        
//             } catch (error) {
//                 console.error('Error fetching scheme details:', error);
//             }
//         };

//         const fetchTransactionHistory = async () => {
//             try {
//                 const transactionsQuery = query(collection(db, 'transactions'), where('userId', '==', cusmid));
//                 const transactionsSnapshot = await getDocs(transactionsQuery);
//                 const transactionsData = transactionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//                 setTransactions(transactionsData);
//                 console.log(transactionsData);
//             } catch (error) {
//                 console.error('Error fetching transaction history:', error);
//             }
//         };

//         fetchTransactionHistory();
//         fetchSchemeDetails();
//         fetchCustomerDetails();
//     }, [cusmid]);

//     const handleDeleteCustomer = async (customerId) => {
//         if (window.confirm('Are you sure you want to delete this customer?')) {
//             try {
//                 await deleteDoc(doc(db, 'users', customerId));
//                 setToastMessage('Customer deleted successfully');
//                 setToastVariant('danger'); // Use 'danger' for the alert variant
//                 setShowToast(true);
//                 navigate('/customers'); // Redirect to the customers list page
//             } catch (error) {
//                 console.error('Error deleting customer:', error);
//                 setToastMessage('Error deleting customer. Please try again.');
//                 setToastVariant('warning'); // Use 'warning' for the alert variant
//                 setShowToast(true);
//             }
//         }
//     };
   
// const handleSaveTransportLocation = async () => {
//     try {
//         const userQuery = query(collection(db, 'users'), where('cusmid', '==', cusmid));
//         const userSnapshot = await getDocs(userQuery);

//         if (!userSnapshot.empty) {
//             const userDoc = userSnapshot.docs[0];
//             const userDocRef = doc(db, 'users', userDoc.id);

//             await updateDoc(userDocRef, {
//                 'address.transport_office_location': newTransportLocation
//             });

//             setCustomer(prev => ({
//                 ...prev,
//                 address: {
//                     ...prev.address,
//                     transport_office_location: newTransportLocation
//                 }
//             }));
//             setShowModal(false);
//             setToastMessage('Transport office location updated.');
//             setToastVariant('success');
//             setShowToast(true);
//         } else {
//             setToastMessage('Customer not found.');
//             setToastVariant('warning');
//             setShowToast(true);
//         }
//     } catch (error) {
//         console.error('Error updating transport office location:', error);
//         setToastMessage('Failed to update location.');
//         setToastVariant('danger');
//         setShowToast(true);
//     }
// };

//     if (!customer) {
        
//             // Render loading screen
//             return (
//               <div className="loading-screen">
//               <Loading/>
//               </div>
//             );
//         }

//     return (
//         <Container fluid className="mt-5">
//             <ToastAlert
//                 show={showToast}
//                 setShow={setShowToast}
//                 message={toastMessage}
//                 variant={toastVariant}
//             />
//             <div className="d-flex justify-content-between align-items-center">
//                 <h1>{customer.name}</h1>
//                 {/* <div>
//                     <Button variant="outline-danger" className='btn' onClick={() => handleDeleteCustomer(customer.cusmid)}>
//                         <FontAwesomeIcon icon={faTrash} className="fa-icon" /> Delete user
//                     </Button>
                  
//                 </div> */}
//             </div>
//             <Row>
//                 <Col md={6} sm={12} className="mb-4">
//                     <p><strong>Email:</strong> {customer.email}</p>
//                     <p><strong>Phone:</strong> {customer.phone}</p>
//                     <p><strong>Address:</strong> {customer.address.address}, {customer.address.city}, {customer.address.state}, {customer.address.postalCode}, {customer.address.country}</p>
//                     <p>
//                         <strong>Transport office area:</strong>{" "}
//                         {customer.address?.transport_office_location || 'N/A'}
//                         <Button
//                             variant="link"
//                             className="p-0 ms-2"
//                             onClick={() => {
//                             setNewTransportLocation(customer.address?.transport_office_location || '');
//                             setShowModal(true);
//                             }}
//                         >
//                             <FontAwesomeIcon icon={faEdit} />
//                         </Button>
//                         </p>

//                 </Col>

//                 <Col md={6} sm={12} className="mb-4">
//                 <Row>
//                     <Col md={4} sm={6} className="mb-4">
//                         <Card className="h-100">
//                             <Card.Body className="d-flex flex-column justify-content-center align-items-center">
//                                 <Card.Text>
//                                     <h1 className="cus-count">{totalSchemes}</h1>
//                                 </Card.Text>
//                                 <Card.Title>
//                                 <center>
//                                     <h6 className="cus-head">Total joined schemes</h6>
//                                     </center>
//                                 </Card.Title>
//                             </Card.Body>
//                         </Card>
//                     </Col>
//                     <Col md={4} sm={6} className="mb-4">
//                         <Card className="h-100">
//                             <Card.Body className="d-flex flex-column justify-content-center align-items-center">
//                                 <Card.Text>
//                                     <h1 className="cus-count">{activeSchemes}</h1>
//                                 </Card.Text>
//                                 <Card.Title>
//                                 <center>
//                                     <h6 className="cus-head">Active schemes</h6>
//                                     </center>
//                                 </Card.Title>
//                             </Card.Body>
//                         </Card>
//                     </Col>  
//                     <Col md={4} sm={6} className="mb-4">
//                         <Card className="h-100">
//                             <Card.Body className="d-flex flex-column justify-content-center align-items-center">
//                                 <Card.Text>
//                                     <h1 className="cus-count">{completedSchemes}</h1>
//                                 </Card.Text>
//                                 <Card.Title>
//                                 <center>
//                                     <h6 className="cus-head">Completed schemes</h6>
//                                     </center>
//                                 </Card.Title>
//                             </Card.Body>
//                         </Card>
//                     </Col>  
//                 </Row>
// </Col>
//             </Row>
//               <Row>
//                 <Col md={4} sm={12} className="mb-4">
//                     <Card className="h-100">
//                         <Card.Body>
//                             <h6>Schemes</h6>
//                             <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
//                             <Table striped bordered hover responsive>
//                                 <thead>
//                                     <tr className='scheme-det-font-head'>
//                                         <th>Scheme name</th>
//                                         <th>no of paid</th>
//                                         <th>over all month</th>
//                                         <th>Purchase quantity</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                 {schemes.map((scheme, index) => (
//                                         <tr key={index} className='scheme-det-font'>

//                                             <td>
//                                                 <Link to={`/scheme/${scheme.id}`} style={{ textDecoration: 'none', color: 'blue' }}>{scheme.name}</Link>
//                                             </td>
//                                             <td>{scheme.paidMonths}</td>
//                                             <td>{scheme.totalMonths}</td>
//                                             <td>{scheme.purchasedQuantity}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                             </div>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 <Col md={8} sm={12} className="mb-4">
//                     <Card className="h-100">
//                         <Card.Body>
//                             <h6>Payments</h6>
//                             <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
//                             <Table striped bordered hover responsive>
//                                 <thead>
//                                     <tr className='scheme-det-font-head'>
//                                         <th>Date</th>
//                                         <th>Transaction ID</th>
//                                         <th>Scheme ID</th>
//                                         <th>Amount</th>
//                                         <th>Type</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                 {transactions.map((transaction, index) => (
//                                         <tr key={index} className='scheme-det-font'>
//                                              <td>{new Date(transaction.paymentDate.seconds * 1000).toLocaleDateString()}</td>
//                                             <td>{transaction.id}</td>
//                                             <td>
//                                                 <Link to={`/scheme/${transaction.schemeId}`} style={{ textDecoration: 'none', color: 'blue' }}>{transaction.schemeId}</Link>
//                                             </td>
//                                             <td>{transaction.paymentAmount}</td>
//                                             <td>{transaction.paymentType}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                             </div>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//             </Row>
//             {/* Modal for editing transport office location */}
//             {customer && (
//                 <div className={`modal fade ${showModal ? 'show d-block' : ''}`} tabIndex="-1">
//                     <div className="modal-dialog">
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">Edit Transport Office Location</h5>
//                                 <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
//                             </div>
//                             <div className="modal-body">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     value={newTransportLocation}
//                                     onChange={(e) => setNewTransportLocation(e.target.value)}
//                                     placeholder="Enter new location"
//                                 />
//                             </div>
//                             <div className="modal-footer">
//                                 <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
//                                 <Button variant="primary" onClick={handleSaveTransportLocation}>Save</Button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//         </Container>
        
//     );
// };

// export default CustomerDetails;



// import React, { useEffect, useState } from 'react';
// import { useParams, Link, useNavigate } from 'react-router-dom';
// import { db } from '../FireBase';
// import { doc, getDoc, query, collection, where, getDocs, updateDoc ,orderBy} from 'firebase/firestore';
// import { Container, Col, Row, Card, Table, Button, Form, Badge } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEdit } from '@fortawesome/free-solid-svg-icons';
// import ToastAlert from '../components/ToastAlert';
// import Loading from '../components/Loading';

// const CustomerDetails = () => {
//   const { cusmid } = useParams();
//   const navigate = useNavigate();
//   const [customer, setCustomer] = useState(null);
//   const [showToast, setShowToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');
//   const [toastVariant, setToastVariant] = useState('');
//   const [schemes, setSchemes] = useState([]);
//   const [transactions, setTransactions] = useState([]);
//   const [filteredTransactions, setFilteredTransactions] = useState([]);
//   const [selectedSchemeId, setSelectedSchemeId] = useState('');
//   const [selectedSchemeInfo, setSelectedSchemeInfo] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [newTransportLocation, setNewTransportLocation] = useState('');
//   const [totalSchemes, setTotalSchemes] = useState(0);
//   const [activeSchemes, setActiveSchemes] = useState(0);
//   const [completedSchemes, setCompletedSchemes] = useState(0);

//   useEffect(() => {
//     const fetchCustomerDetails = async () => {
//       try {
//         const customersQuery = query(collection(db, 'users'), where('cusmid', '==', cusmid));
//         const querySnapshot = await getDocs(customersQuery);
//         if (!querySnapshot.empty) {
//           const customerDoc = querySnapshot.docs[0];
//           setCustomer({ cusmid: customerDoc.id, ...customerDoc.data() });
//         }
//       } catch (error) {
//         console.error('Error fetching customer details:', error);
//       }
//     };

//     const fetchSchemeDetails = async () => {
//       try {
//         const subscriptionsQuery = query(collection(db, 'subscriptions'), where('userId', '==', cusmid));
//         const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
//         const schemePromises = subscriptionsSnapshot.docs.map(async (subscriptionDoc) => {
//           const data = subscriptionDoc.data();
//           const schemeRef = doc(db, 'schemes', data.schemeId);
//           const schemeDoc = await getDoc(schemeRef);
//           if (schemeDoc.exists()) {
//             return {
//               id: schemeDoc.id,
//               ...schemeDoc.data(),
//               paidMonths: data.paidMonths,
//               totalMonths: data.totalMonths,
//               purchasedQuantity: data.quantity,
//             };
//           } else {
//             return null;
//           }
//         });

//         const schemesData = (await Promise.all(schemePromises)).filter(Boolean);
//         setSchemes(schemesData);
//         setTotalSchemes(schemesData.length);
//          setActiveSchemes(schemesData.filter(scheme => parseInt(scheme.paidMonths) < parseInt(scheme.totalMonths)).length);
//           setCompletedSchemes(schemesData.filter(scheme => parseInt(scheme.paidMonths) === parseInt(scheme.totalMonths)).length);
//       } catch (error) {
//         console.error('Error fetching scheme details:', error);
//       }
//     };

//     const fetchTransactionHistory = async () => {
//       try {
//         const transactionsQuery = query(collection(db, 'transactions'), where('userId', '==', cusmid), orderBy("paymentDate", "desc") );
//         const transactionsSnapshot = await getDocs(transactionsQuery);
//         const transactionsData = transactionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//         setTransactions(transactionsData);
//         setFilteredTransactions(transactionsData);
//       } catch (error) {
//         console.error('Error fetching transaction history:', error);
//       }
//     };

//     fetchCustomerDetails();
//     fetchSchemeDetails();
//     fetchTransactionHistory();
//   }, [cusmid]);

//   const handleSchemeFilter = (schemeId) => {
//     setSelectedSchemeId(schemeId);

//     if (!schemeId) {
//       setFilteredTransactions(transactions);
//       setSelectedSchemeInfo(null);
//       return;
//     }

//     const filtered = transactions.filter(t => t.schemeId === schemeId);
//     setFilteredTransactions(filtered);

//     const scheme = schemes.find(s => s.id === schemeId);
//     setSelectedSchemeInfo(scheme || null);
//   };

//   const handleSaveTransportLocation = async () => {
//     try {
//       const userQuery = query(collection(db, 'users'), where('cusmid', '==', cusmid));
//       const userSnapshot = await getDocs(userQuery);

//       if (!userSnapshot.empty) {
//         const userDoc = userSnapshot.docs[0];
//         const userDocRef = doc(db, 'users', userDoc.id);
//         await updateDoc(userDocRef, {
//           'address.transport_office_location': newTransportLocation,
//         });

//         setCustomer(prev => ({
//           ...prev,
//           address: { ...prev.address, transport_office_location: newTransportLocation },
//         }));

//         setShowModal(false);
//         setToastMessage('Transport office location updated.');
//         setToastVariant('success');
//         setShowToast(true);
//       }
//     } catch (error) {
//       console.error('Error updating transport office location:', error);
//       setToastMessage('Failed to update location.');
//       setToastVariant('danger');
//       setShowToast(true);
//     }
//   };

//   if (!customer) {
//     return (
//       <div className="loading-screen">
//         <Loading />
//       </div>
//     );
//   }

//   return (
//     <Container fluid className="mt-5">
//       <ToastAlert
//         show={showToast}
//         setShow={setShowToast}
//         message={toastMessage}
//         variant={toastVariant}
//       />

//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h1>{customer.name}</h1>
//       </div>

//       {/* Customer Info */}
//       <Row>
//         <Col md={6}>
//           <p><strong>Email:</strong> {customer.email}</p>
//           <p><strong>Phone:</strong> {customer.phone}</p>
//           <p>
//             <strong>Address:</strong> {customer.address.address}, {customer.address.city},{" "}
//             {customer.address.state}, {customer.address.postalCode}, {customer.address.country}
//           </p>
//           <p>
//             <strong>Transport office area:</strong>{" "}
//             {customer.address?.transport_office_location || "N/A"}
//             <Button
//               variant="link"
//               className="p-0 ms-2"
//               onClick={() => {
//                 setNewTransportLocation(customer.address?.transport_office_location || "");
//                 setShowModal(true);
//               }}
//             >
//               <FontAwesomeIcon icon={faEdit} />
//             </Button>
//           </p>
//         </Col>
//          <Col md={6} sm={12} className="mb-4">
//                 <Row>
//                     <Col md={4} sm={6} className="mb-4">
//                         <Card className="h-100">
//                             <Card.Body className="d-flex flex-column justify-content-center align-items-center">
//                                 <Card.Text>
//                                     <h1 className="cus-count">{totalSchemes}</h1>
//                                 </Card.Text>
//                                 <Card.Title>
//                                 <center>
//                                     <h6 className="cus-head">Total joined schemes</h6>
//                                     </center>
//                                 </Card.Title>
//                             </Card.Body>
//                         </Card>
//                     </Col>
//                     <Col md={4} sm={6} className="mb-4">
//                         <Card className="h-100">
//                             <Card.Body className="d-flex flex-column justify-content-center align-items-center">
//                                 <Card.Text>
//                                     <h1 className="cus-count">{activeSchemes}</h1>
//                                 </Card.Text>
//                                 <Card.Title>
//                                 <center>
//                                     <h6 className="cus-head">Active schemes</h6>
//                                     </center>
//                                 </Card.Title>
//                             </Card.Body>
//                         </Card>
//                     </Col>  
//                     <Col md={4} sm={6} className="mb-4">
//                         <Card className="h-100">
//                             <Card.Body className="d-flex flex-column justify-content-center align-items-center">
//                                 <Card.Text>
//                                     <h1 className="cus-count">{completedSchemes}</h1>
//                                 </Card.Text>
//                                 <Card.Title>
//                                 <center>
//                                     <h6 className="cus-head">Completed schemes</h6>
//                                     </center>
//                                 </Card.Title>
//                             </Card.Body>
//                         </Card>
//                     </Col>  
//                 </Row>
// </Col>
//       </Row>

//       {/* Scheme Filter + Transaction List */}
//       <Row className="mt-4">
//         <Col md={12}>
//           <Card>
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5>Transactions</h5>
//                 <Form.Select
//                   style={{ width: "250px" }}
//                   value={selectedSchemeId}
//                   onChange={(e) => handleSchemeFilter(e.target.value)}
//                 >
//                   <option value="">All Schemes</option>
//                   {schemes.map((scheme) => (
//                     <option key={scheme.id} value={scheme.id}>
//                       {scheme.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </div>

//               {/* Scheme Info Display */}
//               {selectedSchemeInfo && (
//                 <div className="mb-3 p-3 bg-light rounded">
//                   <strong>Scheme:</strong> {selectedSchemeInfo.name} <br />
//                   <strong>Months Paid:</strong> {selectedSchemeInfo.paidMonths} /{" "}
//                   {selectedSchemeInfo.totalMonths} <br />
//                   <strong>Purchased Quantity:</strong> {selectedSchemeInfo.purchasedQuantity}
//                 </div>
//               )}

//               {/* Transactions Table */}
//               <div style={{ maxHeight: "500px", overflowY: "auto" }}>
//                 <Table striped bordered hover responsive>
//                   <thead>
//                     <tr className="scheme-det-font-head">
//                       <th>Date</th>
//                       <th>Transaction ID</th>
//                       <th>Scheme ID</th>
//                       <th>Amount</th>
//                       <th>Type</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredTransactions.length > 0 ? (
//                       filteredTransactions.map((transaction, index) => (
//                         <tr key={index} className="scheme-det-font">
//                           <td>
//                             {new Date(transaction.paymentDate.seconds * 1000).toLocaleDateString() }
//                           </td>
//                           <td>{transaction.transactionId}</td>
//                           <td>
//                             <Link
//                               to={`/scheme/${transaction.schemeId}`}
//                               style={{ textDecoration: "none", color: "blue" }}
//                             >
//                               {transaction.schemeId}
//                             </Link>
//                           </td>
//                           <td>{transaction.paymentAmount}</td>
//                           <td>{transaction.paymentType}</td>
//                            <td>
//                                 <Badge
//                                     bg={
//                                     transaction.status?.toLowerCase() === 'pending-payment'
//                                         ? 'danger'
//                                         : transaction.status?.toLowerCase() === 'paid'
//                                         ? 'success'
//                                         : 'secondary'
//                                     }
//                                 >
//                                     {transaction.status || 'N/A'}
//                                 </Badge>
//                             </td>

//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center">
//                           No transactions found.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Modal for Editing Transport Office Location */}
//       {customer && (
//         <div className={`modal fade ${showModal ? "show d-block" : ""}`} tabIndex="-1">
//           <div className="modal-dialog">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Edit Transport Office Location</h5>
//                 <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
//               </div>
//               <div className="modal-body">
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={newTransportLocation}
//                   onChange={(e) => setNewTransportLocation(e.target.value)}
//                   placeholder="Enter new location"
//                 />
//               </div>
//               <div className="modal-footer">
//                 <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
//                 <Button variant="primary" onClick={handleSaveTransportLocation}>Save</Button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </Container>
//   );
// };

// export default CustomerDetails;

import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { db } from '../FireBase';
import {
  doc,
  getDoc,
  query,
  collection,
  where,
  getDocs,
  updateDoc,
  orderBy,
} from 'firebase/firestore';
import {
  Container,
  Col,
  Row,
  Card,
  Table,
  Button,
  Form,
  Badge,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import ToastAlert from '../components/ToastAlert';
import Loading from '../components/Loading';

const CustomerDetails = () => {
  const { cusmid } = useParams();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('');

  const [schemes, setSchemes] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);

  const [selectedSchemeId, setSelectedSchemeId] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [newTransportLocation, setNewTransportLocation] = useState('');

  const [totalSchemes, setTotalSchemes] = useState(0);
  const [activeSchemes, setActiveSchemes] = useState(0);
  const [completedSchemes, setCompletedSchemes] = useState(0);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState('');
  const [selectedQuantity, setSelectedQuantity] = useState('all');



  // ------------------------------------------------------------
  // FETCH DATA
  // ------------------------------------------------------------
  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const customersQuery = query(
          collection(db, 'users'),
          where('cusmid', '==', cusmid)
        );
        const querySnapshot = await getDocs(customersQuery);

        if (!querySnapshot.empty) {
          const customerDoc = querySnapshot.docs[0];
          setCustomer({ cusmid: customerDoc.id, ...customerDoc.data() });
        }
      } catch (error) {
        console.error('Error fetching customer:', error);
      }
    };

    const fetchSchemeDetails = async () => {
      try {
        const subscriptionsQuery = query(
          collection(db, 'subscriptions'),
          where('userId', '==', cusmid)
        );
        const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

        const schemePromises = subscriptionsSnapshot.docs.map(async (subDoc) => {
          const data = subDoc.data();
          const schemeRef = doc(db, 'schemes', data.schemeId);
          const schemeDoc = await getDoc(schemeRef);

          if (schemeDoc.exists()) {
            return {
              id: schemeDoc.id,
              ...schemeDoc.data(),
              paidMonths: data.paidMonths,
              totalMonths: data.totalMonths,
              purchasedQuantity: data.quantity,
              subscription:data.subscriptionId
            };
          }
          return null;
        });

        const schemesData = (await Promise.all(schemePromises)).filter(Boolean);
        setSchemes(schemesData);

        setTotalSchemes(schemesData.length);
        setActiveSchemes(
          schemesData.filter(
            (s) => parseInt(s.paidMonths) < parseInt(s.totalMonths)
          ).length
        );
        setCompletedSchemes(
          schemesData.filter(
            (s) => parseInt(s.paidMonths) === parseInt(s.totalMonths)
          ).length
        );
      } catch (error) {
        console.error('Error fetching schemes:', error);
      }
    };

const fetchTransactionHistory = async () => {
  try {
    const transactionsQuery = query(
      collection(db, 'transactions'),
      where('userId', '==', cusmid),
      orderBy('paymentDate', 'desc')
    );

    const snap = await getDocs(transactionsQuery);

    const list = snap.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(t => t.status === 'Paid'); // JS filter

    setTransactions(list);
    setFilteredTransactions(list);
  } catch (error) {
    console.error('Error fetching transactions:', error);
  }
};


    fetchCustomerDetails();
    fetchSchemeDetails();
    fetchTransactionHistory();
  }, [cusmid]);

  useEffect(() => {
    setSelectedQuantity('all');
  }, [selectedSchemeId]);


  // ------------------------------------------------------------
  // FILTER HANDLER
  // ------------------------------------------------------------
  const handleSchemeFilter = (schemeId) => {
  if (schemeId === selectedSchemeId) {
    setSelectedSchemeId('');
    setSelectedQuantity('all');
    setFilteredTransactions(transactions);
    return;
  }

  setSelectedSchemeId(schemeId);
  setSelectedQuantity('all');

  const filtered = transactions.filter(t => t.schemeId === schemeId);
  setFilteredTransactions(filtered);
};



  // ------------------------------------------------------------
  // SAVE TRANSPORT OFFICE LOCATION
  // ------------------------------------------------------------
  const handleSaveTransportLocation = async () => {
    try {
      const userQuery = query(
        collection(db, 'users'),
        where('cusmid', '==', cusmid)
      );
      const snap = await getDocs(userQuery);

      if (!snap.empty) {
        const userDoc = snap.docs[0];
        const userRef = doc(db, 'users', userDoc.id);

        await updateDoc(userRef, {
          'address.transport_office_location': newTransportLocation,
        });

        setCustomer((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            transport_office_location: newTransportLocation,
          },
        }));

        setShowModal(false);
        setToastMessage('Transport office location updated.');
        setToastVariant('success');
        setShowToast(true);
      }
    } catch (error) {
      console.error('Error updating location:', error);
      setToastMessage('Failed to update location.');
      setToastVariant('danger');
      setShowToast(true);
    }
  };


  const getQuantityMapForScheme = (schemeId) => {
  const schemeSubs = schemes.filter(s => s.id === schemeId);

  const map = {};
  schemeSubs.forEach(sub => {
    const qty = Number(sub.purchasedQuantity);
    if (!map[qty]) map[qty] = [];
    map[qty].push(sub.subscription);
  });

  return map; // { 1: [sub1], 2: [sub2], 4: [sub3] }
};

const handleQuantityFilter = (qty) => {
  setSelectedQuantity(qty);

  // All quantities → scheme-level
  if (qty === 'all') {
    setFilteredTransactions(
      transactions.filter(t => t.schemeId === selectedSchemeId)
    );
    return;
  }

  // Quantity-specific → subscription-level
  const qtyMap = getQuantityMapForScheme(selectedSchemeId);
  const subscriptionIds = qtyMap[qty] || [];

  const filtered = transactions.filter(
    t =>
      t.schemeId === selectedSchemeId &&
      subscriptionIds.includes(t.subscriptionId)
  );

  setFilteredTransactions(filtered);
};


  // ------------------------------------------------------------
  // LOADING STATE
  // ------------------------------------------------------------
  if (!customer) {
    return (
      <div className="loading-screen">
        <Loading />
      </div>
    );
  }

  // ------------------------------------------------------------
  // MAIN UI
  // ------------------------------------------------------------
  return (
    <Container fluid className="mt-5">
      {/* Toast Component */}
      <ToastAlert
        show={showToast}
        setShow={setShowToast}
        message={toastMessage}
        variant={toastVariant}
      />

      {/* CUSTOMER HEADER */}
      <h1 className="mb-4">{customer.name}</h1>

      <Row>
        {/* -------------------- CUSTOMER DETAILS -------------------- */}
        <Col md={6}>
          <p>
            <strong>Email:</strong> {customer.email}
          </p>
          <p>
            <strong>Phone:</strong> {customer.phone}
          </p>
          <p>
            <strong>Address:</strong> {customer.address.address},{' '}
            {customer.address.city}, {customer.address.state},{' '}
            {customer.address.postalCode}, {customer.address.country}
          </p>
          <p>
            <strong>Transport office area:</strong>{' '}
            {customer.address?.transport_office_location || 'N/A'}
            <Button
              variant="link"
              className="p-0 ms-2"
              onClick={() => {
                setNewTransportLocation(
                  customer.address?.transport_office_location || ''
                );
                setShowModal(true);
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </Button>
          </p>
        </Col>

        {/* ------------- COUNTERS ------------- */}
        <Col md={6} sm={12} className="mb-4">
          <Row>
            <Col md={4}>
              <Card className="h-100">
                <Card.Body className="text-center">
                  <h1 className="cus-count">{totalSchemes}</h1>
                  <h6 className="cus-head">Total Schemes</h6>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100">
                <Card.Body className="text-center">
                  <h1 className="cus-count">{activeSchemes}</h1>
                  <h6 className="cus-head">Active Schemes</h6>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100">
                <Card.Body className="text-center">
                  <h1 className="cus-count">{completedSchemes}</h1>
                  <h6 className="cus-head">Completed</h6>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* -------------------- SCHEMES + TRANSACTIONS -------------------- */}
      <Row className="mt-4">
        {/* LEFT SIDE — SCHEME LIST */}
        <Col md={4} sm={12} className="mb-4">
          <Card>
            <Card.Body>
              <h6>Schemes</h6>
              <div style={{ maxHeight: '500px', overflowY: 'auto',fontSize:'12px'  }}>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr className="scheme-det-font-head">
                      <th>Name</th>
                      <th>Paid</th>
                      <th>Total</th>
                      <th>Qty</th>
                      <th>Filter</th>
                    </tr>
                  </thead>

                  <tbody>
                    {schemes.map((scheme, index) => (
                      <tr key={index}>
                        <td>
                          <Link
                            to={`/scheme/${scheme.id}`}
                            style={{ textDecoration: 'none', color: 'blue' }}
                          >
                            {scheme.name}
                          </Link>
                        </td>
                        <td>{scheme.paidMonths}</td>
                        <td>{scheme.totalMonths}</td>
                        <td>{scheme.purchasedQuantity}</td>
                        <td>
                         <Button
                            size="sm"
                            variant={
                              selectedSchemeId === scheme.id
                                ? 'primary'
                                : 'outline-primary'
                            }
                            onClick={() => handleSchemeFilter(scheme.id)}
                          >
                            {selectedSchemeId === scheme.id ? 'Clear' : 'View'}
                          </Button>


                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* RIGHT SIDE — TRANSACTIONS */}
        <Col md={8} sm={12}>
          <Card>
            <Card.Body>
             <h5>
                Transactions{' '}
                {selectedSchemeId && (
                  <Badge bg="info" className="ms-2">
                    Scheme: {schemes.find(s => s.id === selectedSchemeId)?.name}
                  </Badge>
                )}

               

               
              </h5>
              {selectedSchemeId && (
                  <>
                    {/* TOTAL QTY */}
                    <Badge bg="success" className="ms-2" style={{fontSize:'16px'}}>
                      Total Qty:{' '}
                      {schemes
                        .filter(s => s.id === selectedSchemeId)
                        .reduce((sum, s) => sum + Number(s.purchasedQuantity), 0)}
                    </Badge>

                    {/* QUANTITY SELECT */}
                    <Form.Select
                      size="sm"
                      className="d-inline-block ms-3"
                      style={{ width: '120px' }}
                      value={selectedQuantity}
                      onChange={(e) => handleQuantityFilter(e.target.value)}
                    >
                      <option value="all">All Qty</option>
                      {Object.keys(getQuantityMapForScheme(selectedSchemeId)).map(qty => (
                        <option key={qty} value={qty}>
                          Qty {qty}
                        </option>
                      ))}
                    </Form.Select>
                  </>
                )}


              <div style={{ maxHeight: '500px', overflowY: 'auto',fontSize:'12px' }}>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr className="scheme-det-font-head">
                      <th>Date</th>
                      <th>Transaction ID</th>
                      <th>Scheme ID</th>
                      <th>Amount</th>
                      <th>Type</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredTransactions.length > 0 ? (
                      filteredTransactions.map((transaction, index) => (
                        <tr key={index}>
                          <td>
                            {new Date(
                              transaction.paymentDate.seconds * 1000
                            ).toLocaleDateString()}
                          </td>
                          <td>{transaction.transactionId}</td>
                          <td>
                            <Link
                              to={`/scheme/${transaction.schemeId}`}
                              style={{ textDecoration: 'none', color: 'blue' }}
                            >
                              {transaction.schemeId}
                            </Link>
                          </td>
                          <td>{transaction.paymentAmount}</td>
                          <td>{transaction.paymentType}</td>
                          <td>
                            <Badge
                              bg={
                                transaction.status?.toLowerCase() ===
                                'pending-payment'
                                  ? 'danger'
                                  : transaction.status?.toLowerCase() === 'paid'
                                  ? 'success'
                                  : 'secondary'
                              }
                            >
                              {transaction.status || 'N/A'}
                            </Badge>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No transactions found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* -------------------- EDIT TRANSPORT MODAL -------------------- */}
      {customer && (
        <div className={`modal fade ${showModal ? 'show d-block' : ''}`}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Transport Office Location</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <input
                  className="form-control"
                  value={newTransportLocation}
                  onChange={(e) => setNewTransportLocation(e.target.value)}
                  placeholder="Enter new location"
                />
              </div>

              <div className="modal-footer">
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSaveTransportLocation}>
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

export default CustomerDetails;
